module.exports = __webpack_public_path__ + "static/img/logo6.7742c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/workbench/img/logo6.png
// module id = dr2s
// module chunks = 3